import React                from "react";
import PrescriptionTable    from './PrescriptionTable';

function PrescriptionDetails({medicines, getTotal, medicineLabel, PickUpLocation, erx}) {

  return (
    <div>
      <PrescriptionTable medicines={medicines} getTotal={getTotal} medicineLabel={medicineLabel} erx={erx}/>
      <PickUpLocation />
    </div>
  );
}

export default PrescriptionDetails;
